import * as requestFromServer from "./chatConversationApis";
import Actions from "../../actions";

// chat access -> get chat conversation list api
export const getChatConversationAction = (dataToBeSent,setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getChatConversation(dataToBeSent);
  if (response) {
    dispatch(Actions.createAction(Actions.GET_CHAT_CONVERSATION_LIST, {chatConversations: response}));
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// chat access -> get chat conversation by id api
export const getChatConversationByIdAction = (dataToBeSent,setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getChatConversationById(dataToBeSent);
  if (response) {
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};